import React from 'react'


export const AppNoItems  = (props: {text:string | JSX.Element, minHeight?:string}) => {
    const {text, minHeight = '40vh'} = props;
    const style = {minHeight: minHeight, fontSize:'large'};
    
    return  <div className='display-flex-center-both' style={style}>{text || ''}</div>
}